import styled from 'styled-components';
import theme from 'src/theme';

export const UnauthorizedWrapper = styled.div`
    text-align: left;
    position: absolute;
    top: 200px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    border-radius: 8px;
    padding: 40px 60px;
    width: 500px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border: 1px solid #e0e0e0;

    h1 {
        font-weight: 300;
        color: ${theme.legacyColors.darkBlue};
        margin-bottom: 20px;
        font-size: 28px;
    }
    a {
        color: ${theme.legacyColors.darkBlue} !important;
        text-decoration: none;
        font-weight: 500;

        &:hover {
            text-decoration: underline;
            color: #1a365d;
        }

        &:focus {
            outline: 2px solid ${theme.legacyColors.darkBlue};
            outline-offset: 2px;
        }
    }
    p {
        font-size: 16px;
        line-height: 1.6;
        color: #666;
        margin-bottom: 30px;
    }

    .message-section {
        margin-bottom: 30px;
    }

    .contact-info {
        background: #f8f9fa;
        padding: 20px;
        border-radius: 6px;
        margin-bottom: 30px;
        border-left: 4px solid ${theme.legacyColors.darkBlue};
    }

    .contact-info h3 {
        margin: 0 0 10px 0;
        color: ${theme.legacyColors.darkBlue};
        font-size: 16px;
    }

    .contact-info p {
        margin: 5px 0;
        font-size: 14px;
    }

    button {
        background: ${theme.legacyColors.darkBlue};
        padding: 15px 40px;
        border-radius: 6px;
        border: 0;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        outline: none;
        cursor: pointer;
        transition: background-color 0.2s ease;
        display: block;
        margin: 0 auto;

        &:hover {
            background: #1a365d;
        }

        &:active {
            transform: translateY(1px);
        }
    }
`;
